import React from "react"
import { graphql } from "gatsby"
/*import { graphql, Link } from "gatsby"
import Img from "gatsby-image"*/
import SiteLayout from "../components/layout"
import SEO from "../components/seo"
/*import Safe from "react-safe"*/
/*import Reviews from "../components/reviews"*/
/*import { Link } from "gatsby"*/
import { TwitchEmbed } from 'react-twitch-embed';
import { Layout, Carousel } from "antd";
import "../css/antd-layout.css"
/*import { TwitchEmbed, TwitchChat, TwitchClip, TwitchPlayer } from 'react-twitch-embed';*/
// import CustomDataTable from "../components/CustomDataTable"

const { Header, Footer, Sider, Content } = Layout;


class IndexPost extends React.Component {

  render() {

    const { data } = this.props;
    console.log("datalogHome", data);

    return (

      <React.Fragment>
        <div className="row flotiq-rich-text-wrap">


          <div className="RaidLogo-wrap">
            {data.data.home.game_logos.map(items => (
                 <img src={`${'https://api.flotiq.com'}${items.url}`} alt={items.fileName} title={items.fileName} width={data.data.home.game_logo_width} height="auto" style={{margin: `30px ${data.data.home.game_logo_margin}px 0`}} />
              ))
            }
          </div>
          <div className="text-center"><h1>{data.data.home.heading}</h1></div>

          {/* <div className="CustomDataTable-wrap"><CustomDataTable /></div> */}

          <section dangerouslySetInnerHTML={{ __html: data.data.home.content}} />

{/*          {data.data.allPage.nodes.map(items => (
            <div className="Catalogue__item col-sm-12 col-md-6 col-lg-4" key={items.id}>
              <div className="details_List">

                <Link to={`/${items.slug}`}>

                  { items.featured_image ? <Img sizes={{
                      "src": `${'https://api.flotiq.com'}/image/600x0/${items.featured_image[0].id}.${items.featured_image[0].extension}`,
                      "aspectRatio": 1.77,
                      "sizes": '',
                      "srcSet": ''
                  }} /> : <div className="no-image">No Image</div>}

                </Link>


                  <div className="details_inner">

                  <h2>
                    <Link to={`/${items.slug}`}>{items.name}</Link>
                  </h2>
                </div>
              </div>
            </div>
          ))}*/}


        </div>
      </React.Fragment>
    );
  }
}

const IndexPage = data => (

  <SiteLayout>
    <SEO
    title="Chofly Elite"
    ogTitle="Chofly Elite"
    ogURL="https://choflyelite-legacy.netlify.com"
    ogDescription="Gaming Content Producer | Currently focussed on RAID Shadow Legends | Plarium Moderator | Twitch Streamer | YouTube Content Creator | Chofly Elite Community Discord"
    ogImage={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    ogImageSecure={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />
    <div className="container home">
      <IndexPost data={data} />
    </div>
    <div className="bgSection">
      <div className="BGsection">
        <div className="recentYouTubeVideos">
          {data.data.allYoutubeVideo ?
            <>
            <h2>Recent YouTube Videos</h2>
            <div className="videos-wrap">
              {data.data.allYoutubeVideo.edges.map(items => (
                <iframe key={items} src={`https://www.youtube-nocookie.com/embed/${items.node.videoId}`} title={items.node.title} alt={items.node.title} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              ))}
            </div>
            </>
          :
            <div className="hidden"></div>
          }
        </div>
        <div className="twitchStream" id="LiveContent">
          <h2 className="mb-4">Live Content</h2>

          <section>
            <span className="TwitchEmbed-heading">ChoflyChoseN</span>
            <TwitchEmbed
              channel="choflychosen"
              id="twitch_embed-choflychosen"
              theme="dark"
              muted
              onVideoPause={() => console.log(':(')}
            />
          </section>

          <section>
            <span className="TwitchEmbed-heading">TriggerhappyJon</span>
            <TwitchEmbed
              channel="triggerhappyjon"
              id="twitch_embed-triggerhappyjon"
              theme="dark"
              muted
              onVideoPause={() => console.log(':(')}
            />
          </section>

          <section>
            <span className="TwitchEmbed-heading">mAdCapperYT</span>
            <TwitchEmbed
              channel="madcapperyt"
              id="twitch_embed-madcapperyt"
              theme="dark"
              muted
              onVideoPause={() => console.log(':(')}
            />
          </section>
    {/*        <TwitchChat channel="cf_chosen" theme="dark" />
        <TwitchClip clip="WealthyBumblingKimchiItsBoshyTime" parent={['mycoolsite.com, anotherawesomesite.net']} />
          <TwitchPlayer video="333014765" />*/}
        </div>
      </div>
    </div>

  </SiteLayout>
)

export default IndexPage

export const query = graphql`
    query PageQuery {

      allPage {

        nodes {
          heading
          content
          featured_image {
            id
            fileName
            extension
          }
          id
          name
          slug
        }

      }


      news(publish: {eq: true}) {
        id
        title
        slug
        featured_image {
            id
            fileName
            extension
          }
        content
        publish
      }


      home {
        heading
        content
        featured_image {
          id
          fileName
          extension
        }
        game_logos {
          extension
          fileName
          url
          size
          id
          height
          width
          type
        }
        game_logo_width
        game_logo_margin
      }

      allYoutubeVideo(filter: {title: {regex: "/^((?!#shorts).)*$/"}, channelId: {eq: "UCDClIEc8CVfPz8nA8lVHiQQ"},}) {
        edges {
          node {
            id
            title
            videoId
            description
            thumbnail {
              url
              height
              width
            }
            channelId
            channelTitle
            publishedAt
            privacyStatus
          }
        }
      }

  }

`


/*
      allTwitchvideo {
        edges {
          node {
            title
            url
            type
          }
        }
      }

      twitchuser {
        display_name
        description
        profile_image_url
      }
*/